import { render, staticRenderFns } from "./AdminWasteDisposals.vue?vue&type=template&id=04638722&scoped=true&"
import script from "./AdminWasteDisposals.vue?vue&type=script&lang=js&"
export * from "./AdminWasteDisposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04638722",
  null
  
)

export default component.exports